import React from 'react';
import MainPageCompenent from './MainPageCompenent';
import LotteriesList from './LotteriesList';

function Lotteries(props) {
    return (
        <MainPageCompenent>
            <LotteriesList />
        </MainPageCompenent>
    );
}

export default Lotteries;